function transitionOut() {
  //console.log('transition current page out');
}

function transitionIn() {
 // console.log('transition new page in');
}
